// extracted by mini-css-extract-plugin
export default {"LegacyLoginForm":"LegacyLoginFormDark__LegacyLoginForm___P5Ttx"};